import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocMaintenanceRoute: InvariantJiraRoute = {
	name: 'eoc-maintenance',
	path: '/jira/ops/teams/:teamId/maintenance',
	exact: true,
};
